export const selectScroll = state => state.scroll;
export const selectFixedMenu = state => state.scroll > 0;



// WEBPACK FOOTER //
// ./src/state/selectors.js